import styles from './AboutUs.module.css';

const VisionCard = () => {
    return ( 
        <div className={` ${styles.visioncard} ${styles.card}`}></div>
     );
}
 
export default VisionCard;